/**
 * PWA layout width helpers.
 * RN-web `Dimensions` / `useWindowDimensions` report the **browser** viewport, not the
 * phone-column shell — guest + auth screens must cap layout to this column so sheets
 * and “%” children don’t stretch or collapse incorrectly on desktop.
 */
import { isWebRuntime } from './runtimeTarget';

/** Matches auth sheet / credential form content width (~phone). */
export const WEB_APP_COLUMN_MAX_WIDTH = 430;

/** Layout width for screens, sheets, and style factories on the current runtime. */
export function resolveWebLayoutWidth(window_width: number): number {
  const w = typeof window_width === 'number' && window_width > 0 ? window_width : WEB_APP_COLUMN_MAX_WIDTH;
  if (!isWebRuntime()) {
    return w;
  }
  return Math.min(w, WEB_APP_COLUMN_MAX_WIDTH);
}
